import { app } from '../../app';

app.service('DestructiveOperationModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (config) => {
        return $uibModal.open({
            component: 'destructiveOperation',
            resolve: {config: () => config},
            windowClass: 'destructive-operation'
        }).result;
    };
}



// WEBPACK FOOTER //
// ./src/portal/modals/destructive-operation/destructive-operation.modal.js